import actions from "@iso/redux/contentList/actions";

const initialState = {
  contents: [],
  total: 0,
  loading: true,
};

export default function contentListReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SEARCH_CONTENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.SEARCH_CONTENTS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        total: action.total,
        loading: false,
      };
    case actions.SEARCH_CONTENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
